import React from 'react'
import { addOutline, removeOutline } from 'ionicons/icons'
import { ICounterInputProps } from './counter-input-props.interface'
import './counter-input.scss'
import { useCounterInput } from 'hooks'
import { BaseButton } from 'components'

const CounterInput: React.FC<ICounterInputProps> = ({ initialValue, minValue, maxValue, onAdd, onRemove, onChangeValue }) => {
  const [counter, add, remove] = useCounterInput(initialValue, minValue, maxValue, onAdd, onRemove, onChangeValue)

  return (
    <div className="edisu-counter-input">
      <BaseButton
        extraClassName="remove-icon"
        disabled={minValue !== undefined && counter <= minValue}
        fill="clear"
        size="small"
        onClickFunction={() => remove()}
        icon={removeOutline}
        iconSlot="icon-only"
      />
      <span className="edisu-guests-num">{counter}</span>
      <BaseButton
        extraClassName="add-icon"
        disabled={maxValue !== undefined && counter >= maxValue}
        fill="clear"
        size="small"
        onClickFunction={() => add()}
        icon={addOutline}
        iconSlot="icon-only"
      />
    </div>
  )
}

export default CounterInput
